import React, { useState } from "react";

import Table from "../../components/Table";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  Switch,
  TextField,
} from "@mui/material";
import { toRegulerCase } from "../../utils/Utils";
import { handleDjangoDataRequest } from "../../utils/apiUtils";
import TableSkeleton from "../../components/TableSkeleton";

import moment from "moment";
import Nodata from "../../components/Nodata";

const toUtcParts = (dateStr, timeStr) => {
  const local = new Date(`${dateStr}T${timeStr}:00`);
  const iso = local.toISOString();
  return { date: iso.slice(0, 10), time: iso.slice(11, 16) };
};

const formatDateParam = (dateStr) => {
  const d = moment(dateStr, "YYYY-MM-DD");
  return `${d.format("MMMM")}%20${d.format("D")}%2C%20${d.format("YYYY")}`;
};

export default function CmLog({ hotelId }) {
  const [rowData, setRowData] = useState();

  const [columnDefs, setColumnDefs] = useState();
  const handleColumn = (data) => {
    if (data) {
      const culumnData = Object.keys(data[0]).map((elm) => ({
        field: elm,
        headerName: toRegulerCase(elm),
      }));
      setColumnDefs(culumnData);
    }
  };

  //-------------------
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("23:59");
  const [useLocal, setUseLocal] = useState(true);
  const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [loading, setLoading] = useState(false);
  const [queried, setQueried] = useState(false);
  const handleShowButton = () => {
    setLoading(true);
    setQueried(true);

    let utcFromDate, utcToDate, utcStart, utcEnd;
    if (useLocal) {
      const from = toUtcParts(selectedDate, startTime);
      const to = toUtcParts(selectedDate, endTime);
      utcFromDate = from.date;
      utcToDate = to.date;
      utcStart = from.time;
      utcEnd = to.time;
    } else {
      utcFromDate = selectedDate;
      utcToDate = selectedDate;
      utcStart = startTime;
      utcEnd = endTime;
    }

    const daterange = `${formatDateParam(utcFromDate)}%20-%20${formatDateParam(utcToDate)}`;
    handleDjangoDataRequest(
      `api/v2/metaAdmin/metaCMLogsForHotel/?hotel_id=${hotelId}&daterange=${daterange}&start_time=${utcStart}&end_time=${utcEnd}`,
    )
      .then((data) => {
        setLoading(false);
        handleColumn(data);
        setRowData(data);
      })
      .catch((err) => setLoading(false));
  };

  return (
    <>
      <Alert severity="info" sx={{ mb: 1 }}>
        {useLocal
          ? `Times are in your local timezone (${browserTz}). They will be converted to UTC automatically. Filter applies to update_time (when the operation happened).`
          : `Times are in UTC. Filter applies to update_time (when the operation happened).`}
      </Alert>
      <Box sx={{ display: "flex", marginBottom: 1, alignItems: "center" }}>
        <FormControlLabel
          control={
            <Switch
              checked={useLocal}
              onChange={(e) => setUseLocal(e.target.checked)}
              size="small"
            />
          }
          label={useLocal ? browserTz : "UTC"}
          sx={{ mr: 1, minWidth: 140 }}
        />
        <TextField
          label="Date"
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          size="small"
          InputLabelProps={{ shrink: true }}
          inputProps={{ max: moment().format("YYYY-MM-DD") }}
          sx={{ width: 160 }}
        />
        <TextField
          label={`Start Time (${useLocal ? browserTz : "UTC"})`}
          type="time"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
          size="small"
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 60 }}
          sx={{ ml: 1, width: 160 }}
        />
        <TextField
          label={`End Time (${useLocal ? browserTz : "UTC"})`}
          type="time"
          value={endTime}
          onChange={(e) => setEndTime(e.target.value)}
          size="small"
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 60 }}
          sx={{ ml: 1, width: 160 }}
        />
        <Button
          variant="custom-button"
          sx={{ ml: 2 }}
          onClick={handleShowButton}
        >
          Show Data
        </Button>
      </Box>
      {loading ? (
        <TableSkeleton />
      ) : queried ? (
        rowData ? (
          <Table rowData={rowData} columnDefs={columnDefs} />
        ) : (
          <Nodata />
        )
      ) : null}
    </>
  );
}
